import { render, staticRenderFns } from "./ModalDeleteTask.vue?vue&type=template&id=1e473ac2&"
import script from "./ModalDeleteTask.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports